<template>
	<div id="content">
		<div class="wrapper">
			<h1>Reifentag Termin-Reservierung</h1>
			<h2>Ihre Termine</h2>
			<ul v-if="reserved.length">
				<li v-for="date in reserved" :key="date.id">
					{{ dateFromString(date.date) }} {{ timeFromString(date.date) }} Uhr – <a href="#" @click.prevent="cancel(date.id)">stornieren</a>
				</li>
			</ul>
			<p v-else>
				Sie haben noch keinen Termin reserviert.
			</p>
			<div v-if="reserved.length < 2">
				<h2>Verfügbare Termine</h2>
				<p>Bitte wählen Sie pro Fahrzeug einen Termin aus (max. zwei)</p>
				<div class="date-selection-wrapper">
					<div v-for="dates in availableDatesGrouped" :key="dates[0].id" class="date-selection">
						<h3>{{ dateFromString(dates[0].date) }}</h3>
						<ul>
							<li v-for="availableDate in dates" :key="availableDate.id" :disabled="!moreAvailable && !selection.includes(availableDate.id)">
								<input v-model="selection" :id="availableDate.id" :value="availableDate.id" type="checkbox" :disabled="!moreAvailable && !selection.includes(availableDate.id)" />
								<label :for="availableDate.id">{{ timeFromString(availableDate.date) }} Uhr</label>
							</li>
						</ul>
					</div>
					<p v-if="availableDatesGrouped.length === 0 && !loading">
						Leider sind zurzeit keine Termine verfügbar.<br />
						Bitte nutzen Sie das Kontaktformular für eine Termin-Anfrage.
					</p>
				</div>
				<!-- <button :disabled="availableDates" -->
				<button :disabled="selection.length === 0" @click="submit">
					{{ selection.length > 1 ? 'Termine reservieren' : 'Termin reservieren' }}
				</button>
			</div>
		</div>
		<transition>
			<div v-show="loading" class="loading-wrapper">
				<div class="lds-ring"><div></div><div></div><div></div><div></div></div>
			</div>
		</transition>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'Reservation',
	data() {
		return {
			availableDates: [],
			reserved: [],
			selection: [],
			clientId: null,
			accessToken: null,
			loading: true,
		}
	},
	computed: {
		availableDatesGrouped() {
			const grouped = {}
			this.availableDates.forEach((availableDate) => {
				const dateString = this.dateFromString(availableDate.date)

				if (!grouped[dateString]) {
					grouped[dateString] = []
				}

				grouped[dateString].push(availableDate)
			})

			return Object.values(grouped)
		},
		moreAvailable() {
			return this.selection.length + this.reserved.length < 2
		},
	},
	mounted() {
		const { clientId, accessToken } = this.$route.query
		this.clientId = clientId
		this.accessToken = accessToken

		// eslint-disable-next-line no-console
		console.log(this.$route.query)

		if (!clientId || !accessToken) {
			alert('Dieser Einladungslink ist ungültig oder abgelaufen.')
			location.href = '/'
			return
		}

		const r1 = this.getAvailableDates()
		const r2 = axios.get('https://api.carmarkt.net/reservations/claimed', {
			params: {
				clientId,
				accessToken,
			},
		})
			.then(({ data }) => {
				this.reserved = data
			})
			.catch(() => {
				location.href = '/'
			})

		Promise.all([r1, r2]).finally(() => {
			this.loading = false
		})
	},
	methods: {
		getAvailableDates() {
			return axios.get('https://api.carmarkt.net/reservations/available', {
				params: {
					clientId: this.clientId,
					accessToken: this.accessToken,
				},
			})
				.then(({ data }) => {
					this.availableDates = data.map((d) => ({ ...d, selected: false }))
				})
		},
		dateFromString(date) {
			return (new Date(date.split(' ')[0])).toLocaleDateString('de-DE', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
		},
		timeFromString(date) {
			const time = date.split(' ')[1]
			const parts = time.split(':')
			return `${parts[0]}:${parts[1]}`
		},
		submit() {
			const requests = []
			this.loading = true

			this.selection.forEach((id) => {
				requests.push(
					axios.post(
						`https://api.carmarkt.net/reservations/${id}/claim`,
						{},
						{
							params: {
								clientId: this.clientId,
								accessToken: this.accessToken,
							},
						})
						.then(({data}) => {
							this.reserved.push(data.reservation)
						})
				)
			})
			Promise.all(requests).then(() => {
				this.selection = []

				this.getAvailableDates().then(() => {
					this.loading = false
				})
			})
		},
		cancel(id) {
			this.loading = true

			axios.post(
				`https://api.carmarkt.net/reservations/${id}/cancel`,
				{},
				{
					params: {
						clientId: this.clientId,
						accessToken: this.accessToken,
					},
				})
				.then(() => {
					this.reserved = this.reserved.filter((d) => d.id !== id)
					this.getAvailableDates().then(() => {
						this.loading = false
					})
				})
		},
	},
}
</script>

<style lang="scss" scoped>
ul {
	list-style: none;
	margin: 1rem 0;
	padding: 0;

	li {
		margin: 0.5rem 0;

		&[disabled] {
			opacity: 0.5;
		}
	}
}

.date-selection-wrapper {
	display: flex;
	justify-content: space-between;
	align-items: stretch;
	flex-wrap: wrap;
	margin: 1rem -0.5rem;
}

.date-selection {
	background-color: #28373B;
	padding: 1rem;
	color: #fff;
	flex-basis: 40%;
	flex-grow: 1;
	margin: 0.5rem;

	h3 {
		color: #fff;
		margin-top: 0;
	}

	input {
		margin-right: 0.5rem;
	}
}

button {
	margin: 1rem 0;
	width: auto;

	&[disabled] {
		opacity: 0.5;
	}
}

.loading-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	background-color: rgba(255, 255, 255, 0.5);
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}
</style>

<style lang="scss">
#content {
	position: relative;
}
</style>
